import React, { useEffect } from 'react';
import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import 'animate.css';
import { v4 as uuidv4 } from 'uuid';
import isEmpty from '../../../validation/is-empty';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheckCircle,
  faTimesCircle,
  faInfoCircle,
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons';
import './ToastNotification.scss';

library.add(faCheckCircle, faTimesCircle, faInfoCircle, faExclamationTriangle);

function TemplateForNotificationTypes({ id, title, message, type, duration }) {
  let customIcon;
  let alertTypeClass;
  switch (type) {
    case 'success':
      customIcon = ['fas', 'check-circle'];
      alertTypeClass = 'own-notification-success';
      break;
    case 'danger':
      customIcon = ['fas', 'times-circle'];
      alertTypeClass = 'own-notification-danger';
      break;
    case 'info':
      customIcon = ['fas', 'info-circle'];
      alertTypeClass = 'own-notification-info';
      break;
    case 'default':
      customIcon = null;
      alertTypeClass = 'own-notification-default';
      break;
    case 'warning':
      customIcon = ['fas', 'exclamation-triangle'];
      alertTypeClass = 'own-notification-warning';
      break;
    default:
      console.log(
        'Impossible to get here due to the filter of the previous component.'
      );
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      store.removeNotification(id);
    }, duration);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, []);

  return (
    <div className={`_own-notification_ ${alertTypeClass}`}>
      <FontAwesomeIcon icon={customIcon} />
      <div className="_own-notification-content">
        <div
          className="_own-notification-close"
          onClick={() => store.removeNotification(id)}
        />
        <div className="_own-notification-title">{title}</div>
        <div className="_own-notification-message">{message}</div>
      </div>
    </div>
  );
}

function toastNotification({
  title,
  message,
  type,
  position,
  duration,
  container,
  content,
}) {
  title = !isEmpty(title) ? title : '';
  message = !isEmpty(message) ? message : '';
  type = !isEmpty(type) ? type : 'default';
  position = !isEmpty(position) ? position : 'top';
  duration = !isEmpty(duration) ? duration : 4000;
  container = !isEmpty(container) ? container : 'top-right';
  const uuid = uuidv4();

  content = isEmpty(content) ? (
    <TemplateForNotificationTypes
      id={uuid}
      title={title}
      message={message}
      type={type}
      duration={duration}
    />
  ) : (
    content
  );

  store.addNotification({
    id: uuid,
    title: title,
    message: message,
    content: content,
    type: type,
    insert: position,
    container: container,
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: duration,
      onScreen: true,
      pauseOnHover: true,
      showIcon: true,
    },
  });
}

export default toastNotification;
